export function setupFormSubmit() {
    const submitBtns = document.querySelectorAll('.login-form__button');
    const userNav = document.querySelector('.navigation__item--user');

    function submitForm() {
        const btnText = this.querySelector('.login-form__button-text');
        const btnLoader = this.querySelector('.load-spinner');
        btnText.style.display = 'none';
        btnLoader.style.display = 'flex';
        setTimeout(() => {
            btnText.style.display = 'block';
            btnLoader.style.display = 'none';
        },3000);

        // When user is logged in
        userNav.querySelector('.icon-checkmark').classList.add('icon-checkmark--checked');
    }

    submitBtns.forEach(submitBtn => {
        submitBtn.addEventListener('click', submitForm);
    });

    const resetPasswordBtn = document.querySelector('.login-form__forgot-password');

    function toggleResetForm() {
        const loginFormWrapper = document.querySelector('form.login-form');
        const resetPasswordForm = loginFormWrapper.querySelector('.login-form--reset-password');
        resetPasswordForm.style.display = 'block';
        const loginForm = loginFormWrapper.querySelector('.login-form--login');
        loginForm.style.display = 'none';
        userNav.addEventListener('mouseleave', resetForms);
        function resetForms () {
            resetPasswordForm.style.display = 'none';
            setTimeout(() => {
                loginForm.style.display = 'block';
            },500);
        }
    }

    if(resetPasswordBtn) {
        resetPasswordBtn.addEventListener('click', toggleResetForm);
    }
}
